import { addBreadcrumb } from '@sentry/react';
import { GlobalErrorCode } from './global-error-handler.types';

export const globalErrorHandler: Record<GlobalErrorCode, () => void> = {
  INVALID_ACCESS_TOKEN_ERROR: () => {
    addBreadcrumb({ message: `Invalid access token error occurred` });
  },
  THROTTLING_ERROR: () => undefined,
  UPDATE_REQUIRED_ERROR: () => undefined,
  CSR_ACCESS_DENIED: () => undefined,
};
